/* eslint-disable import/no-extraneous-dependencies */
import i18n from "i18next"
import LanguageDetector from "i18next-browser-languagedetector"
import Backend from "i18next-http-backend"
import { initReactI18next } from "react-i18next"
import esES from "../i18n/locales/es-ES.json"

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        translation: esES,
      },
    },
    lng: "es",
    fallbackLng: "es",
  })
